export default __webpack_public_path__ + "static/looksrare-617762837c80edf793ceb6c5268f4661.jpeg";